import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import { IVFormErrors, VForm, VTextFieldNumber, VTextFieldNumberReal, useVForm } from '../../../shared/forms';
import { ClientesService } from '../../../shared/services/api/cadastros/ClientesService';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';

interface IFormData {
  idclifab: string;
  nome: string;
  percentual: number;
}
export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  dados?: IFormData;
  onDados: (dados: IFormData) => void;
  onClose: (value?: string) => void;
  nome: string;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'idclifab' | 'nome'>> = yup.object().shape({
  percentual: yup.number().required('Percentual é obrigatório').typeError('Deve ser um número'),
});

export const DialogItens: React.FC<ConfirmationDialogRawProps> = (props) => {
  const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
  const navigate = useNavigate();
  const { onClose, open, dados, onDados } = props;
  const [isLoading, setIsLoading] = useState(false);  

  useEffect(() => {
    if (open && dados && formRef.current) {
      formRef.current.setData(dados); 
      formRef.current.setFieldValue('percentual', dados.percentual);
    }
  }, [open, dados]);

  const handleSave = (formData: IFormData) => {
    setIsLoading(true);

    formValidationSchema
      .validate(formData, { abortEarly: false })
      .then((dadosValidados) => {
        const dadosCompletos = {
          ...dadosValidados,
          idclifab: dados?.idclifab || '',
          nome: dados?.nome || ''
        };
        ClientesService
          .updateByIdItens(props.id, dadosCompletos)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              alert(result.message);
            } else {
              onDados(dadosCompletos);
              onClose();
              if (isSaveAndClose()) {
                navigate('/clientes');
              }
            }
          });
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (error.path) validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleCancel = () => {
    onClose();
  };
  return (
    <Dialog open={open} maxWidth="md">
      <DialogTitle>{props.nome}</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <Grid container direction="column" padding={1}>
            <Grid container item spacing={2}>
              <Grid item xs={12}>
                <VTextFieldNumberReal
                  fullWidth
                  size="small"
                  name="percentual"
                  label="Percentual"
                />
              </Grid>              
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleCancel}>Cancelar</Button>
        <Button variant="outlined" disabled={isLoading} onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog>
  );
};
